import React, { FC } from 'react';
import { Container, Row } from 'react-bootstrap';
import PageTitle from '../../components/layout/pageTitle/PageTitle';

const InternalServerError: FC = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageTitle title="500 Internal Server Error"></PageTitle>
          <Row></Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InternalServerError;
